import z from 'zod';
import {
  createAboutSchema,
  createAttachSchema,
  createAwardSchema,
  createBaseSchema,
  createContactSchema,
  createEducationSchema,
  createExperienceSchema,
  createExperienceEndorsementSchema,
  createSkillEndorsementSchema,
  createLeaderSchema,
  deleteSchema,
  sendOfferSchema,
  skillItemSchema,
  trainingSchema,
  writeCvNoteSchema,
  updateCvNoteSchema,
  cvViewSchema,
  cvSaveAnketSchema,
  statusSchema,
  salarySchema,
  targetPositionSchema,
  updatePictureSchema,
  createEmptyCvSchema,
  boostCvSearchSchema,
  getCvTaggedTypeQuerySchema,
  cvTaggedTypeChangeSchema,
  cvOfferAcceptSchema,
  examSchema,
  internshipSchema,
  trainingCertificateSchema,
  multipleSkillItemSchema,
} from './cv.validation';
import { IOptions } from '../options';

export enum CvDataType {
   CV = 'cv',
   PICTURE = 'picture',
   BASE = 'base',
   CONTACT = 'contact',
   ABOUT = 'about',
   LEADER = 'leader',
   EDUCATION = 'education',
   EXPERIENCE = 'experience',
   AWARD = 'award',
   TRAINING = 'training',
   ATTACHMENT = 'attachment',
   SKILL = 'skill',
   TARGET_POSITION = 'target_position',
   SALARY = 'salary',
   STATUS = 'status',
   EXAM = 'exam',
   INTERNSHIP = 'internship',
   COURSE = 'course',
   TESTLY = 'testly',
}

export type CvBaseInputDto = z.infer<typeof createBaseSchema>;
export type CvContactInputDto = z.infer<typeof createContactSchema>;
export type CvAboutInputDto = z.infer<typeof createAboutSchema>;
export type CvLeaderInputDto = z.infer<typeof createLeaderSchema>;
export type CvEducationInputDto = z.infer<typeof createEducationSchema>;
export type CvExperienceInputDto = z.infer<typeof createExperienceSchema>;
export type CvEmptyInputDto = z.infer<typeof createEmptyCvSchema>;
export type CvAwardInputDto = z.infer<typeof createAwardSchema>;
export type CvDeleteInputDto = z.infer<typeof deleteSchema>;
export type CvAttachInputDto = z.infer<typeof createAttachSchema>;
export type CvTrainingInputDto = z.infer<typeof trainingSchema>;
export type CvTrainingCertificateInputDto = z.output<
  typeof trainingCertificateSchema
>;
export type CvTrainingCertificateFormValues = z.input<
  typeof trainingCertificateSchema
>;
export type CvExamInputDto = z.infer<typeof examSchema>;
export type CvInternshipInputDto = z.infer<typeof internshipSchema>;
export type CvSkillItemInputDto = z.infer<typeof skillItemSchema>;
export type CvMultipleSkillInputDto = z.infer<typeof multipleSkillItemSchema>;
export type CvSkillInputDto = z.infer<typeof skillItemSchema>;
export type CvTargetPositionInputDto = z.infer<typeof targetPositionSchema>;
export type CvSalaryInputDto = z.infer<typeof salarySchema>;
export type CvStatusInputDto = z.infer<typeof statusSchema>;

export type CvViewInputDto = z.infer<typeof cvViewSchema>;
export type CvSaveAnketInputDto = z.infer<typeof cvSaveAnketSchema>;
export type CvWriteNoteInputDto = z.infer<typeof writeCvNoteSchema>;
export type CvUpdateNoteInputDto = z.infer<typeof updateCvNoteSchema>;
export type CvUpdatePictureInputDto = z.infer<typeof updatePictureSchema>;

export type CvSendOfferInputDto = z.infer<typeof sendOfferSchema>;
export type CvExperienceEndorsementInputDto = z.infer<
  typeof createExperienceEndorsementSchema
>;
export type CvSkillEndorsementInputDto = z.infer<
  typeof createSkillEndorsementSchema
>;
export interface CreateCvDataDto {
  langId: number;
  data:
    | CvEmptyInputDto
    | CvLeaderInputDto
    | CvEducationInputDto
    | CvExperienceInputDto
    | CvAwardInputDto
    | CvAttachInputDto
    | CvSkillInputDto
    | CvMultipleSkillInputDto
    | CvTrainingInputDto
    | CvExamInputDto
    | CvInternshipInputDto;
}
export interface UpdateCvDataDto {
   type: CvDataType;
   langId: number;
   data:
      | CvBaseInputDto
      | CvContactInputDto
      | CvAboutInputDto
      | CvLeaderInputDto
      | CvEducationInputDto
      | CvExperienceInputDto
      | CvAwardInputDto
      | CvAttachInputDto
      | CvSkillItemInputDto
      | CvTrainingInputDto
      | CvExamInputDto
      | CvStatusInputDto
      | CvTargetPositionInputDto
      | CvSalaryInputDto;
}
export interface DeleteCvDataDto {
   type: CvDataType;
   data: CvDeleteInputDto;
}

export type CvEducation = {
   id: number;
   anketId: number;
   langId: number;
   countryId: number;
   schoolId: number;
   school: string;
   branchId: number;
   professionId: number;
   pro: string;
   degreeId: number;
   rate: string;
};
export type CvExperience = {
   id: number;
   anketId: number;
   langId: number;
   companyId: number;
   company: string;
   position: string;
   duties: string;
   startOn: string;
   endOn: string;
   status: number;
};
export type CvAward = {
   id: number;
   anketId: number;
   langId: number;
   awardName: string;
   yearOn: number;
   time: number;
   updated: number;
};
export type CvAttach = {
   id: number;
   anketId?: number;
   catId?: number;
   title: string;
   url?: string;
   time?: number;
   updated?: number;
};
export type CvTraining = {
   id: number;
   anketId: number;
   companyId: number;
   langId: number;
   type: number;
   tcenter: string;
   title: string;
   descr: string;
   attachFile: string | null;
   startDate: string | null;
   endDate: string | null;
};
export type CvSkill = {
   id: number;
   anketId: number;
   skillGroup: number;
   skillId?: number;
   skillid: number;
   rateId: number;
   rate?: IOptions | null;
   closestSkillId?: string;
   time?: number;
   updated?: number;
};

export type CvNoteType = {
   id: number;
   anketId: number;
   companyId: number;
   adTitle: string;
   adId: number;
   note: string;
   rate: number;
   time: number;
   hrName: string;
   avatar?: string | null;
   userId: number;
   companyName?: string | null;
};
export type CvOfferType = {
   id: number;
   company: {
      id: number;
      name: string;
      logo: string;
      alias: string;
   };
   job: {
      id: number;
      title: string;
      salary: {
         id: number;
         name_mn: string;
         name_en: string;
      };
   };
   type: {
      status: number;
      text: string;
      seenDate: string;
   };
   dateSubmission: string;
};

export interface CvRightsResponseDto {
   package: CvPackage[];
   tabs: CvTab;
}

export type CvPackage = {
   id: number;
   title: string;
   extends: boolean;
   today: { used: number; limit: number };
   total: { used: number; limit: number };
   bonus: boolean;
   expire: number;
   expireDate: string;
};
export type CvTab = {
   job: number;
};

export type CvTabAnketIds = {
   offers: number[];
   saved: number[];
   seen: number[];
};

export type BoostCvSearchDto = z.infer<typeof boostCvSearchSchema>;

export type CvTaggedTypeInputDto = z.infer<typeof getCvTaggedTypeQuerySchema>;

export type CvTaggedTypeResponseDto = {
   userId: number;
   status: number;
};

export type CvTaggedTypeChangeInputDto = z.infer<
  typeof cvTaggedTypeChangeSchema
>;

export type BoostCvSearchResponseDto = {
   data?: number[];
   total?: number;
};

export type GetCvNotesCountResponseDto = { anketId: number; total: number };

export type AcceptJobOfferPayload = z.infer<typeof cvOfferAcceptSchema>
export type TrainingCertificateInputDto = z.infer<
  typeof trainingCertificateSchema
>;
